export function capitalize(string) {
    const result = string.toLowerCase();
    return result.charAt(0).toUpperCase() + result.slice(1);
}
